export interface BaseKeys {
  isSelectable: boolean;
}

export const baseKeys: BaseKeys = {
  isSelectable: true,
};
